
export const FETCH_DETAILS_START = "customPage/FETCH_DETAILS_START";
export const FETCH_DETAILS_COMPLETED = "customPage/FETCH_DETAILS_COMPLETED";
export const FETCH_DETAILS_FAILED = "customPage/FETCH_DETAILS_FAILED";
